import { useQuery } from "@tanstack/react-query";
import { phone10 } from "../contactLinks";
import { isDncAny } from "./dncRpc";

/** true si algún teléfono o correo del contacto está en do_not_contact. */
export const useIsDnc = (contact?: {
  phone_jsonb?: { number?: string }[] | null;
  email_jsonb?: { email?: string }[] | null;
}) => {
  const values = [
    ...(contact?.phone_jsonb ?? []).map((p) => phone10(p.number)),
    ...(contact?.email_jsonb ?? []).map((e) => e.email?.trim().toLowerCase()),
  ].filter((v): v is string => !!v);
  const { data } = useQuery({
    queryKey: ["dnc", values],
    enabled: values.length > 0,
    queryFn: async () => {
      return isDncAny(values);
    },
  });
  return data ?? false;
};
